const { default: getFrontConfig } = require('./common/getFrontConfig');
const { onOnce } = require('./common/utils/domEvents');
const getAnalyticsEventBus = require('./common/getAnalyticsEventBus');
const {
  onVisitorChoicesConsentSetting,
} = require('./common/utils/consentEvents');

const analyticsEventBus = getAnalyticsEventBus();

function newsletterModalSubmit(form) {
  function handleFormSubmit() {
    // Send info for Analytics
    analyticsEventBus.publish(
      analyticsEventBus.EVENTS.newsletterSubscribed,
      analyticsEventBus.EVENTS.PAYLOADS.newsletterSubscribed.location.popup
    );
  }

  form.addEventListener('submit', handleFormSubmit);
  onOnce(window, 'beforeunload', () => {
    form.removeEventListener('submit', handleFormSubmit);
  });
}

function newsletterModalLanding() {
  const createNewsletterPopUp = require('./components/newsletterPopUp');
  const NEWSLETTER_POPUP_DELAY = getFrontConfig().newsletterPopUp.delayLanding;
  const NEWSLETTER_POPUP_ENABLED =
    getFrontConfig().newsletterPopUp.enabledInLanding;
  const CLOSED_MODAL = 'closedNewsletterModalLanding';
  const { isInEditModePD = false } = window;

  const alreadyClosed = window.localStorage.getItem(CLOSED_MODAL);
  const shouldShowModal =
    NEWSLETTER_POPUP_ENABLED && !alreadyClosed && !isInEditModePD;

  if (shouldShowModal) {
    const newsletterPopUp = createNewsletterPopUp();
    if (newsletterPopUp) {
      const timeoutOpenNewsletterModal = () => {
        setTimeout(() => {
          newsletterPopUp.open();
        }, NEWSLETTER_POPUP_DELAY);
      };

      onVisitorChoicesConsentSetting(timeoutOpenNewsletterModal);

      $(newsletterPopUp.modal).on('hide.bs.modal', () => {
        window.localStorage.setItem(CLOSED_MODAL, true);
      });

      const form = newsletterPopUp.modal.querySelector(
        '.newsletter-popup-form'
      );
      newsletterModalSubmit(form);
    }
  }
}

function init() {
  newsletterModalLanding();
}

module.exports = {
  init,
};
